import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styled from "@emotion/styled";
import { Carousel as ReactCarousel } from "react-responsive-carousel";
import { Box } from "@mui/material";

function CarouselImages({ items, renderContent }) {
  return (
    <StyledReactCarousel
      showArrows={false}
      showStatus={false}
      showThumbs={false}
      swipeable
      emulateTouch
      infiniteLoop
    >
      {items.map(
        (
          {
            attributes: {
              title,
              description,
              button_path,
              button_text,
              modal_button_text,
              modal_content,
              image,
              second_button_text,
              second_button_path,
            },
          },
          index,
        ) => (
          <Box
            key={`slide${index}`}
            sx={{
              minHeight: "650px",
              width: "100%",
              background: `linear-gradient(90deg, rgba(27,54,93,1) 0%, rgba(126,5,5,0) 100%), url(${
                image?.data?.attributes?.formats?.large?.url ||
                image?.data?.attributes?.url
              })`,
              backgroundSize: "cover",
            }}
          >
            {renderContent(
              title,
              description,
              button_path,
              button_text,
              modal_button_text,
              modal_content,
              second_button_path,
              second_button_text,
            )}
          </Box>
        ),
      )}
    </StyledReactCarousel>
  );
}

const StyledReactCarousel = styled(ReactCarousel)`
  .carousel .control-dots .dot {
    box-shadow: none;
    background: #d50032;
    width: 33px;
    height: 6px;
    border-radius: 5px;
  }
`;

export default CarouselImages;
